function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, ref, reactive, computed, watch } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import searchMixin from "@/mixin/search";
import AddDialog from "./project-demo-add-dialog.vue";
import PushDialog from "./project-demo-push-dialog.vue";
import PushRecordDialog from "./project-demo-push-record-dialog.vue";
import { DemoType } from "@/api/demo/type";
import { deleteProjectDemo, getProjectDemoList } from "@/api/demo/project";
import { format } from "date-fns";
import { Message } from "element-ui";
export default defineComponent({
    name: "ProjectDemo",
    mixins: [
        searchMixin
    ],
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination,
        AddDialog: AddDialog,
        PushDialog: PushDialog,
        PushRecordDialog: PushRecordDialog
    },
    setup: function setup(props) {
        var fetchList = function fetchList() {
            loading.value = true;
            var params = _objectSpreadProps(_objectSpread({}, query.value), {
                type: DemoType.VIDEO,
                page: query.value.page,
                page_size: query.value.page_size
            });
            getProjectDemoList(params).then(function(res) {
                list.value = res.data.data.list || [];
                pagination.total = res.data.data.total;
            }).finally(function() {
                loading.value = false;
            });
        };
        var handleDelete = function handleDelete(row) {
            loading.value = true;
            deleteProjectDemo({
                id: Number(row.id)
            }).then(function() {
                Message.success("\u5220\u9664\u6210\u529F");
                fetchList();
            }).finally(function() {
                loading.value = false;
            });
        };
        var loading = ref(false);
        var query = ref({
            page: 1,
            page_size: 15,
            id: "",
            name: "",
            order: "",
            src_adv_id: "",
            src_project_id: ""
        });
        watch(function() {
            return query.value;
        }, function() {
            query.value.src_adv_id = query.value.src_adv_id ? Number(query.value.src_adv_id) : query.value.src_adv_id;
            fetchList();
        });
        var pagination = reactive({
            total: 0
        });
        // 表单数据
        var list = ref([]);
        var formItemList = computed(function() {
            return [
                {
                    type: "input",
                    prop: "id",
                    params: {
                        clearable: true,
                        placeholder: "\u8BF7\u8F93\u5165demo id"
                    }
                },
                {
                    type: "input",
                    prop: "name",
                    params: {
                        clearable: true,
                        placeholder: "\u8BF7\u8F93\u5165demo\u540D\u79F0"
                    }
                },
                {
                    type: "input",
                    prop: "src_project_id",
                    params: {
                        clearable: true,
                        placeholder: "\u8BF7\u8F93\u5165\u6765\u6E90\u9879\u76EEid"
                    }
                },
                {
                    prop: "src_adv_id",
                    type: "business",
                    subtype: "advertiser-selector",
                    params: {
                        clearable: true,
                        filterable: true,
                        collapseTags: true,
                        style: "width: 220px;"
                    }
                }, 
            ];
        });
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: "demo id",
                    prop: "id",
                    width: 120,
                    align: "center"
                },
                {
                    slot: "thumbnail"
                },
                {
                    label: "demo\u540D\u79F0",
                    prop: "name",
                    align: "center"
                },
                {
                    label: "\u6765\u6E90\u9879\u76EEid",
                    prop: "src_project_id",
                    align: "center"
                },
                {
                    label: "\u6765\u6E90\u5E7F\u544A\u4E3B",
                    prop: "src_adv_name",
                    align: "center"
                },
                {
                    label: "\u521B\u5EFA\u65F6\u95F4",
                    prop: "created_time",
                    align: "center",
                    width: 130,
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            var time = row.created_time ? "".concat(format(row.created_time * 1000, "YYYY/MM/DD HH:mm")) : "-";
                            return time;
                        }
                    }
                },
                {
                    label: "\u6700\u540E\u66F4\u65B0\u65F6\u95F4",
                    prop: "updated_time",
                    align: "center",
                    width: 130,
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            var time = row.updated_time ? "".concat(format(row.updated_time * 1000, "YYYY/MM/DD HH:mm")) : "-";
                            return time;
                        }
                    }
                },
                {
                    slot: "action"
                }, 
            ];
        });
        return {
            loading: loading,
            query: query,
            pagination: pagination,
            list: list,
            formItemList: formItemList,
            tableColumnConfig: tableColumnConfig,
            DemoType: DemoType,
            handleDelete: handleDelete,
            fetchList: fetchList
        };
    }
});
